import { FormEvent, useCallback, useState } from 'react'
import { Link } from 'react-router-dom'
import { useMyself } from '../UserContext'

const INPUT_CLASS = 'mt-1 block w-full appearance-none rounded-md border border-gray-300 bg-white px-3 py-2 shadow-sm focus:border-primary focus:outline-none sm:text-sm'

export const LoginForm = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [rememberMe, setRememberMe] = useState(false)
  const { login } = useMyself() || {}

  const handleLogin = useCallback((event: FormEvent) => {
    event.preventDefault()
    if (login) {
      login(email, password, rememberMe)
    }
  }, [login, email, rememberMe, password])

  return (
    <div>
      <form
        onSubmit={handleLogin}
        className={'space-y-5'}
      >
        <div>
          <label
            htmlFor={'email'}
            className={'block text-sm font-medium text-gray-700'}
          >
            E-Mail-Adresse
          </label>
          <input
            id={'email'}
            name={'email'}
            type={'email'}
            autoFocus
            autoComplete={'username'}
            required
            value={email}
            onChange={event => setEmail(event.target.value)}
            className={INPUT_CLASS}
          />
        </div>

        <div>
          <label
            htmlFor={'password'}
            className={'block text-sm font-medium text-gray-700'}
          >
            Passwort
          </label>
          <input
            id={'password'}
            name={'password'}
            type={'password'}
            autoComplete={'current-password'}
            required
            value={password}
            onChange={event => setPassword(event.target.value)}
            className={INPUT_CLASS}
          />
        </div>

        <div className={'flex items-center justify-between gap-4'}>
          <label className={'flex items-center gap-2 text-sm text-gray-900'}>
            <input
              id={'remember-me'}
              name={'remember-me'}
              type={'checkbox'}
              className={'h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary'}
              checked={rememberMe}
              onChange={event => setRememberMe(event.target.checked)}
            />
            Eingeloggt bleiben
          </label>
          <Link
            to={'/passwort-vergessen'}
            className={'text-sm font-medium text-primary hover:text-primary-200'}
          >
            Passwort vergessen?
          </Link>
        </div>

        <button
          type={'submit'}
          className={'flex w-full justify-center rounded-full bg-primary-200 px-6 py-3 text-sm font-semibold text-white hover:bg-primary-100 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary'}
        >
          Anmelden
        </button>
      </form>

      <p className={'mt-6 border-t border-sand-200 pt-5 text-sm text-gray-600'}>
        Noch kein Konto?{' '}
        <Link
          to={'/registrieren'}
          className={'font-semibold text-primary hover:underline'}
        >
          Jetzt registrieren
        </Link>
      </p>
    </div>
  )
}
